export class DefaultMsxServiceConfig {
    constructor(requestor) {
        this.requestor = requestor;
    }
    get baseUrl() {
        return "https://merchandising-site-experience.prod.merch.vpsvc.com/api/v1";
    }
}
//# sourceMappingURL=MsxServiceConfig.js.map